class accidental_insurance {
    constructor() {
const WEBDOCLIFEINSDAILY1 = "WEBDOCLIFEINSDAILY1";
const WEBDOCLIFEINSDAILY2 = "WEBDOCLIFEINSDAILY2";
const WEBDOCLIFEINSDAILY3 = "WEBDOCLIFEINSDAILY3";
const WEBDOCLIFEINSDAILY4 = "WEBDOCLIFEINSDAILY4";
const WEBDOCLIFEINSDAILY5 = "WEBDOCLIFEINSDAILY5";

      this.items = [
        {
          serviceId: 1,
          pid: WEBDOCLIFEINSDAILY1,
          name: "WebdocLifeInsDaily1",
          serviceName: "Accidental Life Insurance",
          badge: "Basic",
          coverage: "300,000",
          price:"4.0",
          bgColorClass: "bg-info",
          description: `<p><strong>Life Insurance</strong> is a valuable product that provides good value to Jazz customers’ family who get financial relief in case of death (any cause), benefit is doubled in case of accidental death. Online doctor services are also available with this product.</p>
<ul>
<li><strong>Coverage Amount:</strong> Up to Rs. 300,000</li>
<li><strong>Waiting Period:</strong> 7 days</li>
<li><strong>Subscription:</strong> Daily</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 60 (sixty) days of the occurrence of death. The claim can only be made by the next of Kin</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Be within the age bracket of 18-59 years</li>
<li>Death certificate is required</li>
</ul>`,
          type: "insurance",
        },
        {
          serviceId: 2,
          pid: WEBDOCLIFEINSDAILY2,
          name: "WebdocLifeInsDaily2",
          serviceName: "Accidental Life Insurance",
          badge: "Gold",
          coverage: "600,000",
          price:"8.5",
          bgColorClass: "bg-warning",
          description: `<p><strong>Life Insurance</strong> is a valuable product that provides good value to Jazz customers’ family who get financial relief in case of death (any cause), benefit is doubled in case of accidental death. Online doctor services are also available with this product.</p>
<ul>
<li><strong>Coverage Amount:</strong> Up to Rs. 600,000</li>
<li><strong>Waiting Period:</strong> 7 days</li>
<li><strong>Subscription:</strong> Daily</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 60 (sixty) days of the occurrence of death. The claim can only be made by the next of Kin</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Be within the age bracket of 18-59 years</li>
<li>Death certificate is required</li>
</ul>`,
          type: "insurance",
        },
        {
          serviceId: 3,
          pid: WEBDOCLIFEINSDAILY3,
          name: "WebdocLifeInsDaily3",
          serviceName: "Accidental Life Insurance",
          badge: "Platinum",
          coverage: "900,000",
          price:"12.5",
          bgColorClass: "bg-info",
          description: `<p><strong>Life Insurance</strong> is a valuable product that provides good value to Jazz customers’ family who get financial relief in case of death (any cause), benefit is doubled in case of accidental death. Online doctor services are also available with this product.</p>
<ul>
<li><strong>Coverage Amount:</strong> Up to Rs. 900,000</li>
<li><strong>Waiting Period:</strong> 7 days</li>
<li><strong>Subscription:</strong> Daily</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 60 (sixty) days of the occurrence of death. The claim can only be made by the next of Kin</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Be within the age bracket of 18-59 years</li>
<li>Death certificate is required</li>
</ul>`,
          type: "insurance",
        },

//         {
//           serviceId: 4,
//           pid: WEBDOCLIFEINSDAILY4,
//           name: "WebdocLifeInsDaily4",
//           serviceName: "Webdoc Life Insurance",
//           badge: "Standard",
//           coverage: "1,200,000",
//           price:"17.0",
//           bgColorClass: "bg-info",
//           description: `<p><strong>Life Insurance</strong> is a valuable product that provides good value to Jazz customers’ family who get financial relief in case of death (any cause), benefit is doubled in case of accidental death. Online doctor services are also available with this product.</p>
// <ul>
// <li><strong>Coverage Amount:</strong> Up to Rs. 1,200,000 for accidental life insurance</li>
// <li><strong>Insurance Period:</strong> 30 days</li>
// <li><strong>Subscription:</strong> Daily</li>
// </ul>
// <p><strong>Seamless Claims Process:&nbsp;</strong></p>
// <ul>
// <li>Settled directly with the claimants within 3 working days of document submission</li>
// <li>End-to-end support and handholding to claimant</li>
// <li>Death certificate is required</li>
// </ul>`,
//           type: "insurance",
//         },

//         {
//           serviceId: 5,
//           pid: WEBDOCLIFEINSDAILY5,
//           name: "WebdocLifeInsDaily5",
//           serviceName: "Webdoc Life Insurance",
//           badge: "Premium",
//           coverage: "1,500,000",
//           price:"21.0",
//           bgColorClass: "bg-info",
//           description: `<p><strong>Life Insurance</strong> is a valuable product that provides good value to Jazz customers’ family who get financial relief in case of death (any cause), benefit is doubled in case of accidental death. Online doctor services are also available with this product.</p>
// <ul>
// <li><strong>Coverage Amount:</strong> Up to Rs. 1,500,000 for accidental life insurance</li>
// <li><strong>Insurance Period:</strong> 30 days</li>
// <li><strong>Subscription:</strong> Daily</li>
// </ul>
// <p><strong>Seamless Claims Process:&nbsp;</strong></p>
// <ul>
// <li>Settled directly with the claimants within 3 working days of document submission</li>
// <li>End-to-end support and handholding to claimant</li>
// <li>Death certificate is required</li>
// </ul>`,
//           type: "insurance",
//         },

      ];
    }
  
    getAllItems() {
      return this.items;
    }
  }
  
  export default accidental_insurance;
  